module.exports = __webpack_public_path__ + "static/media/podium-3rd.c4a6441e.png";